// extracted by mini-css-extract-plugin
module.exports = {"board":"Board_board__15fms"};